import { secureGet, securePost, secureGetPdf } from 'config/apiConfig';
import { uniqBy, orderBy } from 'lodash';

/* ── Commandes list (server-side search/filter/paginate) ────────── */
export const searchCommandes = async ({
  page = 0, size = 10, sort = 'date,desc',
  search = '', expeditionIds = null, statuts = null,
  origins = null, startDate = '', endDate = '',
}) => {
  const params = new URLSearchParams({ page, size, sort });
  const body = {};
  if (search) body.search = search;
  if (expeditionIds && expeditionIds.length > 0) body.expeditionIds = expeditionIds;
  if (statuts && statuts.length > 0) body.statuts = statuts;
  if (origins && origins.length > 0) body.origins = origins;
  if (startDate) body.startDate = startDate;
  if (endDate) body.endDate = endDate;
  const { data } = await securePost(`/carts/commandes/search?${params.toString()}`, body);
  return data;
};

/* ── Commande detail ────────────────────────────────────────────── */
export const getCommandeDetail = async (id) => {
  const { data } = await secureGet(`/carts/commandes/${id}`);
  return data;
};

export const getSalesCommandeDetail = async (id) => {
  const { data } = await secureGet(`/carts/commandes/sales/${id}`);
  return data;
};

/* ── Confirm delivery — single ──────────────────────────────────── */
export const confirmDelivery = async (id) => {
  const { data } = await securePost(`/carts/commandes/${id}/confirm`, {});
  return data;
};

/* ── Confirm delivery — Sales order ─────────────────────────────── */
export const confirmSalesDelivery = async (opsOrderId) => {
  const { data } = await securePost(`/carts/commandes/sales/${opsOrderId}/confirm`, {});
  return data;
};

/* ── Confirm delivery — Sales bulk ──────────────────────────────── */
export const confirmSalesDeliveryBulk = async (opsOrderIds) => {
  const { data } = await securePost('/carts/commandes/sales/confirm-bulk', opsOrderIds);
  return data;
};

/* ── Confirm delivery — bulk ────────────────────────────────────── */
export const confirmDeliveryBulk = async (ids) => {
  const { data } = await securePost('/carts/commandes/confirm-bulk', ids);
  return data;
};

/* ── Timeline ───────────────────────────────────────────────────── */
export const getOrderTimeline = async (bcNumber) => {
  const { data } = await secureGet(`/carts/timeline/${bcNumber}`);
  return uniqBy(orderBy(data || [], 'date', 'asc'), 'status');
};

/* ── Download facture PDF ───────────────────────────────────────── */
export const downloadOrderFacture = async (reference) => {
  const response = await secureGetPdf(`/orders/getFacture/${reference}`, {
    headers: { 'content-type': 'application/json', accept: 'application/pdf' },
  });
  return response;
};
